module.exports = __webpack_public_path__ + "static/media/Frankie.39872724.jpg";